import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReceiptUrl from './ReceiptUrl';
import { getEventDate } from "../helpers/helpers";
import Translation from '../../shared/Translation';

class EventSummary extends Component {
    render() {
        return(
            <div className={this.getWrapperCSSClass()}>
                <div className="event-summary__details">
                    <h2 className="event-summary__name">
                        <Translation
                          interpolation={{
                            event_name: this.props.name
                          }}
                        >
                          {'checkout__tickets_for_event'}
                        </Translation>
                    </h2>
                    {!this.props.isRecurring && <div className="event-summary__dates">
                        <span>
                            {getEventDate(this.props.start,
                              this.props.end,
                              this.props.locale,
                              this.props.uiConfig.hide_event_time || this.props.hideEventDateTime,
                              this.props.uiConfig.hide_event_date_and_time || this.props.hideEventDateTime)}
                        </span>
                    </div>}
                    {!this.props.uiConfig.hide_venue &&
                    <div className="event-summary__location">
                        <address>
                            <span className="event-summary__location-name">{this.props.venueName} </span>
                            <span className="event-summary__location-line">{this.props.venueAddress}</span>
                        </address>
                    </div>
                    }
                    {!this.props.hideAgeLimit && (
                      <div className="event-summary__location">
                          <Translation>{this.props.ages}</Translation>
                      </div>
                    )}
                </div>
                {(this.props.location === "confirmation" && !!this.props.receiptUrl) && <ReceiptUrl url={this.props.receiptUrl} />}
            </div>
        )
    }

    getWrapperCSSClass = () => {
        if(!this.props.location) {
            return "tickets__event-summary";
        }

        if(this.props.location === "confirmation") {
            return "confirmation-event-details";
        }
    }

    getImageUrl = () => {
        return "url(" + this.props.image + ")";
    }
}

EventSummary.propTypes = {
    locale: PropTypes.string.isRequired,
    name: PropTypes.string,
    start: PropTypes.string,
    venueName: PropTypes.string,
    venueAddress: PropTypes.string,
    image: PropTypes.node, // not sure if this is the right proptype for image
    location: PropTypes.string,
    uiConfig: PropTypes.object,
    childEvent: PropTypes.any,
    receiptUrl: PropTypes.string,
    hideEventDateTime: PropTypes.bool,
    ages: PropTypes.string,
    hideAgeLimit: PropTypes.bool
}

export default EventSummary
